import { render, staticRenderFns } from "./Edig.vue?vue&type=template&id=3f84b54c"
import script from "./Edig.vue?vue&type=script&lang=js"
export * from "./Edig.vue?vue&type=script&lang=js"
import style0 from "./Edig.vue?vue&type=style&index=0&id=3f84b54c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports